import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import type { ClinicalTagDto } from '~/backend/connector-next-api/connector-next-schemas';

type TagChipsProps = {
    /** The ids of the tags to show, in order. */
    tagIds: readonly string[];
    /** Every clinical tag, retired ones included; undefined until they have loaded. */
    tags: readonly ClinicalTagDto[] | undefined;
};

/**
 * A patient's clinical tags as small coloured labels. A tag reads "…" until
 * the tags have loaded, and "Unknown tag" for an id no listed tag has, so a
 * tag is never silently hidden from the patient it is on.
 */
export default function TagChips({ tagIds, tags }: TagChipsProps) {
    const intl = useIntl();
    if (tagIds.length === 0) {
        return null;
    }
    return (
        <Box
            component="span"
            sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 0.5 }}
        >
            {tagIds.map((id) => {
                const tag = tags?.find((each) => each.id === id);
                const color = tag?.color ?? 'text.secondary';
                return (
                    <Chip
                        key={id}
                        variant="tag"
                        label={
                            tag?.name ??
                            (tags === undefined
                                ? '…'
                                : intl.formatMessage({
                                      id: 'patientList.tags.unknown',
                                  }))
                        }
                        sx={{
                            color,
                            borderColor: color,
                            bgcolor: 'transparent',
                        }}
                    />
                );
            })}
        </Box>
    );
}
